module.exports = __webpack_public_path__ + "img/instant-booking.70a07d0e.svg";